import { mutate } from "swr";
import type { SWRConfiguration } from "swr";

/**
 * This function clears the SWR cache. Useful for when you want to invalidate all cached data, e.g., after a logout.
 * @see https://swr.vercel.app/docs/mutation#mutate-multiple-items
 */
export const clearSWRCache = () => mutate(() => true, undefined, { revalidate: false });
/**
 * This is the default SWR configuration. It sets the focus throttle interval and deduping interval.
 */
export const swrConfig: SWRConfiguration = {
  focusThrottleInterval: 60000,
  /** @default 2000 */
  dedupingInterval: 2000,
};
